// Sticky Header
export function stickyHeader() {
  document.addEventListener('DOMContentLoaded', function () {
    const headerSection = document.getElementById('shopify-section-header');

    if (headerSection) {
      let headerHeight = headerSection.getBoundingClientRect().bottom;
      document.body.style.setProperty('--header-height', `${headerHeight}px`);

      window.addEventListener('resize', () => {
        headerHeight = headerSection.getBoundingClientRect().bottom;
        document.body.style.setProperty('--header-height', `${headerHeight}px`);
      });

      if (window.stickyHeaderEnabled) {
        document.body.classList.add('header-is-sticky');
        headerSection.classList.add('sticky', 'top-0', 'z-30', 'shadow-sm');

        let lastScrollTop = 0;
        let scrollOffset = 150;

        window.addEventListener('scroll', () => {
          let currentScroll = window.pageYOffset || document.documentElement.scrollTop;
          let stickyHeaderHeight = headerSection.getBoundingClientRect().bottom;

          if (currentScroll > 0) {
            document.body.classList.add('is-scrolled');
          } else {
            document.body.classList.remove('is-scrolled');
            stickyHeaderHeight = headerHeight;
          }

          if (currentScroll > scrollOffset) {
            document.body.classList.add('is-scrolled-offset');
          } else {
            document.body.classList.remove('is-scrolled-offset');
          }

          if (currentScroll > lastScrollTop) {
            document.body.classList.remove('is-scrolling-up');
            if (currentScroll > scrollOffset) stickyHeaderHeight = 0;
          } else {
            document.body.classList.add('is-scrolling-up');
          }

          lastScrollTop = currentScroll <= 0 ? 0 : currentScroll;

          document.body.style.setProperty('--header-height', `${stickyHeaderHeight}px`);
        });
      }
    }
  });
}
